<template>
  <footer class="footer">
    &copy; Michael Woods O'Rourke
  </footer>
</template>

<script>
export default {
  name: 'FooterPrismic'
}
</script>

<style scoped>
.footer {
  padding: 40px 0;
  margin: 0 auto;
  text-align: center;
  border-top: 1px solid #DADADA;
}
.logo {
  width: 100px;
}
</style>
